var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionsBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 250,
    viewBox: "0 0 1920 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 250,
    fill: "#151C2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1389.44 119.77C1389.51 115.427 1393 111.919 1397.22 111.92L1444.28 111.973C1448.57 111.853 1452.08 115.339 1452.13 119.752L1452.08 151.062C1452.01 155.404 1448.52 158.912 1444.3 158.911L1397.24 158.858C1393.02 158.857 1389.51 155.37 1389.39 151.079L1389.44 119.77ZM1444.3 107.438L1405.81 107.458C1405.95 107.215 1405.97 106.901 1406.11 106.657L1421.86 79.3777C1423.97 75.7241 1428.96 74.3858 1432.61 76.4952L1473.53 100.12C1477.31 102.3 1478.53 107.224 1476.42 110.878L1460.67 138.157C1459.68 139.862 1458.28 141.164 1456.55 141.628L1456.54 119.702C1456.58 112.9 1451.1 107.468 1444.3 107.438Z",
    fill: "#1D2A44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M501.839 119.77C501.767 115.427 498.281 111.919 494.06 111.92L447 111.973C442.708 111.853 439.2 115.339 439.15 119.752L439.203 151.062C439.274 155.404 442.761 158.912 446.982 158.911L494.042 158.858C498.263 158.857 501.771 155.37 501.891 151.079L501.839 119.77ZM446.98 107.438L485.475 107.458C485.335 107.215 485.316 106.901 485.175 106.657L469.425 79.3777C467.316 75.7241 462.321 74.3858 458.668 76.4952L417.748 100.12C413.973 102.3 412.756 107.224 414.866 110.878L430.616 138.157C431.6 139.862 433.001 141.164 434.73 141.628L434.737 119.702C434.707 112.9 440.177 107.468 446.98 107.438Z",
    fill: "#1D2A44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionsBanner);
export default __webpack_public_path__ + "static/media/subscriptions-banner.c0c37959c562e0ebc694a03bfcfdb156.svg";
export { ForwardRef as ReactComponent };